import axios, {
  type AxiosInstance,
  type AxiosRequestConfig,
  type AxiosResponse,
} from "axios";
import { IBaseResponseModel } from "@/app/models/types/base-response-model";
import { get_encrypted_value } from "@/lib/encrypt-decrypt";

class ApiService {
  private static instance: ApiService;
  private axiosInstance: AxiosInstance;

  private constructor() {
    this.axiosInstance = axios.create({
      baseURL: process.env.NEXT_PUBLIC_BASE_URL,
    });

    // Request interceptor for JWT
    this.axiosInstance.interceptors.request.use(
      (config) => {
        config.headers["x-api-key"] = this.getApiKey();
        return config;
      },
      (error) => Promise.reject(error)
    );
  }
  
  public getApiKey(): string {
    return get_encrypted_value(
      JSON.stringify({ date_time: new Date().toUTCString() })
    );
  }

  public static getInstance(): ApiService {
    if (!ApiService.instance) {
      ApiService.instance = new ApiService();
    }
    return ApiService.instance;
  }

  public async get<T>(
    endpoint: string,
    params?: Record<string, any>,
    config?: AxiosRequestConfig
  ): Promise<IBaseResponseModel<T>> {
    try {
      const response: AxiosResponse<IBaseResponseModel<T>> =
        await this.axiosInstance.get(endpoint, { ...config, params });

      return response.data;
    } catch (error: any) {
      throw error;
    }
  }

  public async post<T>(
    endpoint: string,
    data?: any,
    config?: AxiosRequestConfig
  ): Promise<IBaseResponseModel<T>> {
    try {
      const response: AxiosResponse<IBaseResponseModel<T>> =
        await this.axiosInstance.post(endpoint, data, config);
      return response.data;
    } catch (error: any) {
      throw error;
    }
  }
}

export const apiService = ApiService.getInstance();
